import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import React from 'react';

import { GiftCardEntryForm } from './gift-card-entry-form';
import { SelectedGiftCard } from './selected-gift-card';

const GiftCardEntry = observer(() => {
  const { OrderStore } = useRootStore();
  const { giftCard } = OrderStore.payment;

  if (giftCard) {
    return <SelectedGiftCard />;
  }

  return <GiftCardEntryForm />;
});

export { GiftCardEntry };
